export default {
	cartTabMenu: {
		label: "Panier",
		emptyButton: "Vider",
		emptyButtonTooltip: "Retire tous les articles du panier.",
	},
	cartTabMenuItem: {
		removeTooltip: "Retire l'article du panier.",
	},
	cartPosition: {
		showParts: "Afficher les pièces",
	},
	cartPositionItem: {
		materialLabel: "Matériau :",
		articleIdLabel: "Numéro Blexon :",
		certificateLabel: "Certificat :",
		revalidateButton: "Blexoniser",
		quantityUnit: "{quantity} pce",
		quantityPlaceholder: "pce",
		removeTooltip:
			"Retire l'article du panier. Ne retire pas l'article des listes de pièces.",
		addToSavedCartTooltip: "Ajouter la position à la liste de pièces actuelle",
		loadError: "L'article n'a pas pu être chargé.",
	},
	currentCart: {
		title: "Panier",
		emptyButton: "Vider",
		emptyButtonTooltip: "Retire tous les articles du panier.",
		createListButton: "Créer une liste de pièces",
		createListButtonTooltip: "Créer une liste de pièces à partir du panier.",
		emptyCartText: "Le panier est vide. Rendez-vous sur {link} pour ajouter de nouveaux articles au panier.",
		emptyCartLinkText: "'Articles'",
		newCartDialog: {
			title: "Nouvelle liste de pièces",
			text: "Le panier sera enregistré comme liste de pièces sous le nom suivant :",
			nameLabel: "Nom de la nouvelle liste de pièces",
			saveButtonTooltip: "Enregistre le panier comme liste de pièces.",
		},
		nameExistsError: "Une liste de pièces portant ce nom existe déjà.",
		messages: {
			cartSaved: "La liste de pièces a été enregistrée.",
		},
	},
	savedCarts: {
		title: "Listes de pièces",
		noCartsText:
			"Aucune liste de pièces enregistrée pour l'instant. Ajoutez des pièces au panier pour créer une nouvelle liste de pièces à partir du panier.",
		selectPlaceholder: "Sélectionner une liste...",
		itemTooltipQuantity: "Quantité : {quantity}",
		deleteButton: "Supprimer",
		deleteButtonTooltip: "Supprimer la liste de pièces.",
		quantityLabel: "Quantité",
		quantityPlaceholder: "pce",
		addButtonTooltip:
			"Ajoute tous les articles de la liste de pièces au panier. Pour les articles déjà présents, la quantité est augmentée.",
		addButtonMultiple: "Ajouter {amount} x au panier",
		addButtonSingle: "Ajouter au panier",
		removeArticleTooltip: "Retirer de la liste de pièces",
		addArticleTooltip: "Ajouter au panier",
		deleteDialog: {
			title: "Supprimer la liste de pièces",
			text: "Êtes-vous sûr de vouloir supprimer cette liste de pièces ?",
			text2: "Les articles contenus dans la liste ne seront pas supprimés.",
			confirmButton: "Supprimer",
			confirmButtonTooltip: "Supprime définitivement la liste de pièces.",
		},
		messages: {
			articlesAdded: "Les articles de la liste de pièces ont été ajoutés au panier.",
			articleAdded:
				"{quantity} pièce(s) ajoutée(s) au panier. {oldQuantity} + {quantity} = {newQuantity}",
			articleRemoved: "L'article a été retiré de la liste de pièces.",
			cartDeleted: "La liste de pièces a été supprimée.",
		},
	},
};
